/* 846: ブランド別商品スライダー

   Liquid の collections.all.products は先頭50商品しか回せず、ブランドの
   全商品を拾えなかった（beruf baggage は12商品中3件、LUAUS は2商品中0件）。
   Shopify のフィルタはサーバー側で効くので、フィルタ済みの一覧を
   templates/collection.slider-json.liquid から JSON で取得する。

   ブランドが増えてもテーマ側の作業は不要。ページ本文に
   <div id="vendor-slider:ブランド名"></div> を置くだけで動く。

   JS が動かない場合は、Liquid が出している「すべてを表示する」リンクが
   そのまま残る（フィルタ済み一覧への導線は必ず確保される）。

   旧実装は id="productSlider" 固定・グローバル変数だったため、1ページに
   2つ置くと片方のボタンがもう片方を動かしていた。ここでは要素ごとに状態を持つ。
*/
(function () {
  'use strict';

  var GAP = 20;

  function slideWidth(track) {
    var first = track.firstElementChild;
    return first ? first.getBoundingClientRect().width + GAP : 0;
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function buildSlide(p, soldOutLabel) {
    /* loading="lazy" は付けない。
       このスライダーは transform で横に動かすため、画面外のスライドが
       入ってきても遅延読み込みが再評価されず、画像が出ないままになる。
       スライダー自体が読み込み後に JS で差し込まれるので、初期表示への影響もない。 */
    var media = p.image
      ? '<img class="vendor-slider-846__img" src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.title) + '">'
      : '';
    var price = p.compare_at_price
      ? '<del>' + escapeHtml(p.compare_at_price) + '</del><span>' + escapeHtml(p.price) + '</span>'
      : '<span>' + escapeHtml(p.price) + '</span>';
    var soldout = p.available ? '' : ' <span class="vendor-slider-846__soldout">' + escapeHtml(soldOutLabel) + '</span>';

    return '<div class="vendor-slider-846__slide">' +
      '<a class="vendor-slider-846__link" href="' + escapeHtml(p.url) + '">' +
        '<div class="vendor-slider-846__media">' + media + '</div>' +
        '<h4 class="vendor-slider-846__name">' + escapeHtml(p.title) + '</h4>' +
        '<p class="vendor-slider-846__price">' + price + soldout + '</p>' +
      '</a>' +
    '</div>';
  }

  function setUpControls(root, track) {
    var controls = root.querySelector('[data-controls]');
    if (!controls) return;

    var index = 0;

    function maxIndex() {
      var w = slideWidth(track);
      if (!w) return 0;
      var visible = Math.max(1, Math.floor(track.parentElement.offsetWidth / w));
      return Math.max(0, track.children.length - visible);
    }

    function apply() {
      var limit = maxIndex();
      if (index > limit) index = limit;
      track.style.transform = 'translateX(' + (-(index * slideWidth(track))) + 'px)';
      controls.querySelectorAll('[data-dir]').forEach(function (btn) {
        var dir = Number(btn.getAttribute('data-dir'));
        btn.disabled = dir < 0 ? index <= 0 : index >= limit;
      });
    }

    if (maxIndex() === 0) {
      controls.hidden = true;
      return;
    }

    controls.hidden = false;
    controls.querySelectorAll('[data-dir]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        index += Number(btn.getAttribute('data-dir'));
        apply();
      });
    });
    window.addEventListener('resize', apply);
    apply();
  }

  function load(root) {
    var track = root.querySelector('[data-track]');
    var endpoint = root.getAttribute('data-endpoint');
    if (!track || !endpoint) return;

    var soldOutLabel = root.getAttribute('data-soldout-label') || '';
    var limit = parseInt(root.getAttribute('data-limit'), 10) || 10;

    /* Accept: application/json を付けると Shopify が 404 を返す。
       ヘッダーは付けずに取得し、本文を自前で JSON.parse する
       （このテンプレートの Content-Type は text/html のため）。 */
    fetch(endpoint)
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (body) {
        return JSON.parse(body);
      })
      .then(function (data) {
        var items = (data && data.products) || [];
        if (!items.length) return;
        track.innerHTML = items.slice(0, limit).map(function (p) {
          return buildSlide(p, soldOutLabel);
        }).join('');
        setUpControls(root, track);
      })
      .catch(function () {
        /* 失敗しても「すべてを表示する」リンクが残るので、何もしない */
      });
  }

  function init() {
    document.querySelectorAll('[data-vendor-slider]').forEach(load);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
